import { render, staticRenderFns } from "./WeaponList.vue?vue&type=template&id=1e648476&scoped=true&"
import script from "./WeaponList.vue?vue&type=script&lang=js&"
export * from "./WeaponList.vue?vue&type=script&lang=js&"
import style0 from "./WeaponList.vue?vue&type=style&index=0&id=1e648476&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e648476",
  null
  
)

export default component.exports